import { render, staticRenderFns } from "./ROI.vue?vue&type=template&id=07b1031a&scoped=true"
import script from "./ROI.vue?vue&type=script&lang=js"
export * from "./ROI.vue?vue&type=script&lang=js"
import style0 from "./ROI.vue?vue&type=style&index=0&id=07b1031a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b1031a",
  null
  
)

export default component.exports